import React, { useEffect, useState } from "react";
import { ReactComponent as BackArrow } from "../../Icons/BorderBackArrow.svg";
import {
  Box,
  Grid,
  Typography,
  Stack,
  Button,
  IconButton,
  Divider,
  CircularProgress,
} from "@mui/material";
import {
  PrimaryTypography,
  SecondaryTypography,
  StyledSecondaryTypography,
  TypographyDefault,
  StyledSecondaryServiceTypography,
} from "../../Theme";
import { ReactComponent as EditIcon } from "../../Icons/Edit.svg";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as DeleteBorderIcon } from "../../Icons/DeleteOutline.svg";
import axiosInstance from "../../AxiosInstance";
import moment from "moment";
import { showToast } from "../../CommonComponents/Toaster";
import RelocateDialogComponent from "../../components/RelocateDialogComponent";
import ConfirmRelocateDialogComponent from "../../components/ConfirmRelocateDialogComponent";
import { useDialog } from "../../contexts/DialogContext";

const ReviewAccount = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [openRelocateDialog, setOpenRelocateDialog] = useState(false);
  const { showDialog, closeDialog } = useDialog();
  const [openConfirmRelocateDialog, setOpenConfirmRelocateDialog] =
    useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [companyData, setCompanyData] = useState("");
  const reviewstyle = {
    minHeight: "61px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "10px 0",
  };
  const getCompanyData = () => {
    setLoading(true);
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}company/${id}`)
      .then((res) => {
        setCompanyData(res?.data?.data?.company);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getCompanyData();
  }, []);
  console.log("companyData", companyData);
  const formatDate = (isoDateString) => {
    return moment(isoDateString).format("DD MMM YYYY, HH:mm");
  };
  const handleDelete = async () => {
    setDeleteLoading(true);
    if (companyData?.properties_count > 0) {
      showDialog({
        title: "Unable to Delete",
        content: `There are currently ${companyData?.properties_count} active projects under ${companyData?.name}.Please transfer these projects to another company before proceeding with deletion.`,
        actions: (
          <Box display="flex" gap="20px">
            <Button
              onClick={() => {
                closeDialog();
              }}
              variant="white"
            >
              Back
            </Button>
            <Button
              variant="Standard"
              onClick={() => {
                closeDialog();
                setOpenRelocateDialog(true);
              }}
            >
              Relocate Projects
            </Button>
          </Box>
        ),
        icon: "failure",
      });
    } else {
      try {
        const response = await axiosInstance.delete(
          `${process.env.REACT_APP_API_URL}company/${id}`
        );
        if (response.status === 200) {
          showToast("Company deleted successfully");
          navigate("/company");
          setDeleteLoading(false);
        }
        console.log(response.data);
      } catch (error) {
        console.log(error);
        showToast("Please try again later", "error");
        setDeleteLoading(false);
      } finally {
        setDeleteLoading(false);
      }
    }
  };
  const handleRelocateClose = () => {
    setOpenRelocateDialog(false);
  };
  const handleConfirmRelocateClose = () => {
    setOpenConfirmRelocateDialog(false);
  };

  const handleRelocateSubmit = () => {
    setOpenRelocateDialog(false);
    setOpenConfirmRelocateDialog(true);
  };
  return loading ? (
    <Box
      sx={{ width: "100%", height: "90vh" }}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <CircularProgress />
    </Box>
  ) : (
    <>
      <RelocateDialogComponent
        open={openRelocateDialog}
        setSelectedCompany={setSelectedCompany}
        selectedCompany={selectedCompany}
        onClose={handleRelocateClose}
        onSubmit={handleRelocateSubmit}
      />
      <ConfirmRelocateDialogComponent
        open={openConfirmRelocateDialog}
        onClose={handleConfirmRelocateClose}
      />
      <BackArrow
        onClick={() => navigate("/company")}
        style={{ marginBottom: "20px", cursor: "pointer" }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <PrimaryTypography>{companyData?.name}</PrimaryTypography>
          <StyledSecondaryServiceTypography>
            Last Updated: {formatDate(companyData?.updated_at)}
          </StyledSecondaryServiceTypography>
        </Box>
        {deleteLoading ? (
          <CircularProgress size={25} color="inherit" />
        ) : (
          <DeleteBorderIcon
            style={{ cursor: "pointer" }}
            onClick={handleDelete}
          />
        )}
      </Box>
      <Box
        mt={3}
        component="div"
        boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
        borderRadius="8px 8px 8px 8px"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
            borderRadius: "8px 8px 0px 0px",
          }}
        >
          <Stack direction="row" alignItems="center" gap="10px">
            <SecondaryTypography>Company Details</SecondaryTypography>
          </Stack>
          <Button
            sx={{
              width: "83px",
              height: "36px",
              padding: "8px 6px 8px 14px",
            }}
            variant="outlined"
            onClick={() => navigate(`/edit-company/${id}`)}
          >
            {" "}
            Edit{" "}
            <IconButton sx={{ paddingLeft: "10px" }}>
              {" "}
              <EditIcon width="14px" />
            </IconButton>
          </Button>
        </Stack>
        <Grid
          container
          xs={12}
          gap="2.8%"
          sx={{
            backgroundColor: "white",
            padding: "30px 16px 30px 16px",
            border: "1px solid #E5E7EB",
            borderRadius: "0px 0px 8px 8px",
          }}
        >
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Company Name</StyledSecondaryTypography>
            <TypographyDefault>{companyData?.name}</TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>Country</StyledSecondaryTypography>
            <TypographyDefault>{companyData?.country}</TypographyDefault>
          </Grid>
          <Divider
            sx={{
              borderTop: "1px solid #F3F4F6",
              width: "100%",
              marginTop: "10px",
            }}
          />
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Company Email Address
            </StyledSecondaryTypography>
            <TypographyDefault>{companyData?.email}</TypographyDefault>
          </Grid>
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Contact Number
            </StyledSecondaryTypography>
            <TypographyDefault>
              +{companyData?.country_code} {companyData?.phone}
            </TypographyDefault>
          </Grid>
          <Divider
            sx={{
              borderTop: "1px solid #F3F4F6",
              width: "100%",
              marginTop: "10px",
            }}
          />
          <Grid xs={12} sm={5.8} sx={reviewstyle}>
            <StyledSecondaryTypography>
              Company Address
            </StyledSecondaryTypography>
            <TypographyDefault>{companyData?.address}</TypographyDefault>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ReviewAccount;
